<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`${keyPrefix}-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// common
import Separator from '~/components/library/Separator.vue';
import FormContainer from '~/components/library/FormContainer.vue';
import Test from '~/components/theme8/components/Test.vue';
import InfoCard from '~/components/theme8/components/InfoCard.vue';
import TeamCard from '~/components/theme8/components/TeamCard.vue';
import OurBlog from '~/components/theme8/blogs/OurBlog.vue';
import ContactForm from '~/components/theme8/components/ContactForm.vue';
import LatestProperties from '~/components/theme8/properties/LatestProperties.vue';
import SmallBox from '~/components/theme8/components/SmallBox.vue';
import ContactFormCard from '~/components/theme8/components/ContactFormCard.vue';
import ManageCard from '~/components/library/ManageCard.vue';
import OurGuide from '~/components/theme8/components/OurGuide.vue';

export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },

    keyPrefix: {
      required: false,
      type: String,
      default: 'dynamicComponent',
    },
  },

  components: {
    Separator,
    ContactForm,
    FormContainer,
    LatestProperties,
    OurGuide,
    SmallBox,
    Test,
    InfoCard,
    TeamCard,
    OurBlog,
    ContactFormCard,
    ManageCard,
  },
});
</script>
